<template>
  <div class="hp-contact">
    <section class="main-banner-hp">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="mb-content-wrapper">
              <h3>HelpNow AI Contact Center</h3>
              <h2>HelpNow AI에 대해 <br/>문의하기</h2>
              <p>데모 요청, 제품 문의, 견적 문의, 사업 제휴 문의, 기타 요청 사항을 남겨주시면 <br/>담당자 확인 후 빠른 시간 내에 연락 드리겠습니다.</p>
              <a target="_blank" href="https://drive.google.com/file/d/1iOFQFeoE27yhEcdRNMsf7cjiHknwAdZv/view?usp=sharing" class="btn_white">상품소개서</a>
            </div>
          </div>
          <div class="col-lg-6 align-self-end">
            <div class="mb-image txt_center">
              <img src="@/assets/image/img_helpnow_contact.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="row-hp-pd hp-aicc-info">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1 class="tit_hp">HelpNow AI에 대해 문의하기</h1>
            <h3 class="subtit_hp">데모 요청, 제품 문의, 견적 문의, 사업 제휴 문의, 기타 요청 사항을 남겨주시면 <br/>담당자 확인 후 빠른 시간 내에 연락 드리겠습니다.</h3>
          </div>
        </div>
        <!--contact-->
        <div class="row">
          <div class="col-md-12">
            <p class="txt_field">항목은 필수 입력 항목입니다.</p>
          </div>
          <div class="col-md-12">
            <div class="well well-sm">
              <form class="form-horizontal"  
                name="submit-to-google-sheet"
                data-email="mihwa.yoo@bespinglobal.com"
                novalidate="true"
                @submit="clickInquire">
                <fieldset>
                  <div class="row">
                    <div class="col-md-6">
                      <!-- Name input-->
                      <div class="form-group01">
                        <label class="control-label essential" for="name">이름</label>
                        <div class="input">
                          <span class="text-limit-message">{{name.value.length}} / {{name.maxlength}}</span>
                          <input id="name" name="name" type="text" class="form-control" :maxlength="name.maxlength" :invalid="name.error" v-model="name.value" @change="inputChange(name)">
                          <p v-if="name.error" class="invalid-message">이름을 입력해주세요.</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <!-- Phone input-->
                      <div class="form-group01">
                        <label class="control-label essential" for="phone">연락처</label>
                        <div class="input">
                          <span class="text-limit-message">{{phone.value.length}} / {{phone.maxlength}}</span>
                          <input id="phone" name="phone" type="text" class="form-control" :maxlength="phone.maxlength" :invalid="phone.error" v-model="phone.value" @change="inputChange(phone)">
                          <p v-if="phone.error" class="invalid-message">연락처를 입력해주세요.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <!--Company input-->
                      <div class="form-group01">
                        <label class="control-label essential" for="company">회사명</label>
                        <div class="input">
                          <span class="text-limit-message">{{company.value.length}} / {{company.maxlength}}</span>
                          <input id="company" name="company" type="text" class="form-control" :maxlength="company.maxlength" :invalid="company.error" v-model="company.value" @change="inputChange(company)">
                          <p v-if="company.error" class="invalid-message">회사명을 입력해주세요.</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <!--Company input-->
                      <div class="form-group01">
                        <label class="control-label" for="position">직책</label>
                        <div class="input">
                          <span class="text-limit-message">{{position.value.length}} / {{position.maxlength}}</span>
                          <input id="position" name="position" type="text" class="form-control" :maxlength="position.maxlength" v-model="position.value" @change="inputChange(position)">
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <!-- Email input-->
                      <div class="form-group01">
                        <label class="control-label essential" for="email">이메일</label>
                        <div class="input">
                          <span class="text-limit-message">{{email.value.length}} / {{email.maxlength}}</span>
                          <input id="email" name="email" type="email" class="form-control" :maxlength="email.maxlength" :invalid="email.error" v-model="email.value" @change="inputChange(email)">
                          <p v-if="email.error" class="invalid-message">이메일을 입력해주세요.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Message body -->
                  <div class="box_contact">
                    <div class="col-md-12">
                      <div class="form-group01">
                        <label class="control-label essential" for="message">문의내용</label>
                        <div class="textarea">
                          <span class="text-limit-message">{{message.value.length}} / {{message.maxlength}}</span>
                          <textarea class="form-control" id="message" name="message" rows="5" :maxlength="message.maxlength" :invalid="message.error" v-model="message.value" @change="inputChange(message)"></textarea>
                          <p v-if="message.error" class="invalid-message">문의내용을 입력해주세요.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Message body -->
                  <div class="box_contact">
                    <div class="col-md-12">
                      <div class="form-group01">
                        <!-- <label class="control-label essential" for="message">개인정보 수집 및 이용에 동의합니다. (필수)</label> -->
                        <p class="description" for="ch01">
                          <label for="agree" class="control-label essential">
                            <input type="checkbox" id="agree" name="agree" v-model="agreeForm.value" :invalid="agreeForm.error&&!agreeForm.value"> 개인정보처리방침 내용에 동의합니다.</label>
                        </p>
                        <div class="form-control textarea-div" readonly>- 수집하는 개인정보 항목: 이름, 회사명, 연락처, 이메일 주소
                          - 작성해주시는 개인 정보는 문의 접수 및 고객 불만 해결을 위해 1년간 보관됩니다. 
                          - 본 동의를 거부할 수 있으나, 미동의 시 문의 접수가 불가능합니다.
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Form actions -->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group01 mr-t50">
                        <div class="col-md-12 txt_center">
                          <button type="submit" class="btn_purple">문의하기</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
        <!--contact-->
      </div>
    </section>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'Contact',
    components: {
      
    },
    data() {
      return {
        name: {
          value: "",
          error: false,
          maxlength: 50
        },
        position:{
          value: "",
          maxlength: 50
        },
        company: {
          value: "",
          error: false,
          maxlength: 50
        },
        phone: {
          value: "",
          error: false,
          maxlength: 50
        },
        email: {
          value: "",
          error: false,
          maxlength: 50
        },
        message: {
          value: "",
          error: false,
          maxlength: 500
        },
        agreeForm: {
          value: false,
          error: false
        },
        submitted: false, 
        apiUrl: "https://script.google.com/macros/s/AKfycbxQowaB7o51fdXfr3TOwinlNv2_t-CJUndyoZ4YNeZhpWccJyg-m-aHKAai_WKdFfnH/exec"
      }
    },
    computed: {},
    watch: {},
    created(){},
    mounted(){},
    beforeDestroy() {},
    methods: {
      inputChange(item){
        item.error = false;
        if(!item.value.trim()&&this.submitted){
          item.error = true;
        }
      },
      async clickInquire(event) {
        event.preventDefault(); 

        this.submitted = true
        this.name.error = false;
        this.company.error = false;
        this.phone.error = false;
        this.email.error = false;
        this.message.error = false;
        this.agreeForm.error = false;
        let errorCheck = false;
        let message = "";

        if(!this.name.value.trim()){
          message += `이름: ${this.name.value},`
          this.name.error = true;
          errorCheck = true;
        }
        if(!this.phone.value.trim()){
          message += `연락처: ${this.phone.value},`
          this.phone.error = true;
          errorCheck = true;
        }
        if(!this.company.value.trim()){
          message += `회사명: ${this.company.value},`
          this.company.error = true;
          errorCheck = true;
        }
        message += `직책: ${this.position.value},`
        if(!this.email.value.trim()){
          message += `이메일: ${this.email.value},`
          this.email.error = true;
          errorCheck = true;
        }
        if(!this.message.value.trim()){
          message += `문의내용: ${this.message.value}`
          this.message.error = true;
          errorCheck = true;
        }
        if(!this.agreeForm.value){
          this.agreeForm.error = true;
          errorCheck = true;
        }
        if(errorCheck){
          return;
        }

        let formName = document.forms['submit-to-google-sheet']
        let formData = new FormData(formName); 

        console.log("formData:", formData)

        fetch(this.apiUrl, { 
          method: 'POST', 
          mode: 'no-cors',
          body: formData
        })
        .then( response => { 
          console.log('response:', response)
          this.$toasted.global.showMessage({ message: `문의하기 접수가 완료되었습니다.`, type: "success" });
          this.name = { value: "", error: false, maxlength: 50 }
          this.position = { value: "", maxlength: 50 }
          this.company = { value: "", error: false, maxlength: 50 }
          this.phone = { value: "", error: false, maxlength: 50 }
          this.email = { value: "", error: false, maxlength: 50 }
          this.message = { value: "", error: false, maxlength: 500 }
          this.agreeForm = { value: false, error: false }
        })
        .catch( error => { 
          console.log('error:', error)
          this.$toasted.global.showMessage({ message: `문제가 발생했습니다. 다시 시도하거나 관리자에게 문의해주세요.`, type: "warning" });
        })

        
        // message = `이름: ${this.name.value},\n 연락처: ${this.phone.value},\n 회사명: ${this.company.value},\n 직책: ${this.position.value},\n 이메일: ${this.email.value},\n 문의내용: ${this.message.value}`

        // try{
        //   await axios.post(process.env.API_SERVER + '/send', { summary: message }, { headers: { 'Content-type': 'application/json; charset=UTF-8' } })
        //   this.$toasted.global.showMessage({ message: `문의하기 접수가 완료되었습니다.`, type: "success" });
        //   this.name = { value: "", error: false, maxlength: 50 }
        //   this.position = { value: "", maxlength: 50 }
        //   this.company = { value: "", error: false, maxlength: 50 }
        //   this.phone = { value: "", error: false, maxlength: 50 }
        //   this.email = { value: "", error: false, maxlength: 50 }
        //   this.message = { value: "", error: false, maxlength: 500 }
        //   this.agreeForm = { value: false, error: false }
        // }catch(e){
        //   console.log(e)
        //   this.$toasted.global.showMessage({ message: `문제가 발생했습니다. 다시 시도하거나 관리자에게 문의해주세요.`, type: "warning" });
        // }

      },
    }
  }
</script>

<style lang="scss" scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/Contact.vue